import { render, staticRenderFns } from "./PageBrief.vue?vue&type=template&id=4734425d&scoped=true&"
import script from "./PageBrief.vue?vue&type=script&lang=js&"
export * from "./PageBrief.vue?vue&type=script&lang=js&"
import style0 from "./PageBrief.vue?vue&type=style&index=0&id=4734425d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4734425d",
  null
  
)

export default component.exports